export const error = {
  isRequired: 'Este campo es obligatorio',
  email: 'Por favor, ingresa una dirección de correo electrónico válida',
  minlength: 'El número de caracteres no debe ser menor que {{requiredLength}}',
};
